/**
 * Applies the logistic sigmoid function.
 */
export function sigmoid(value) {
  return 1 / (1 + Math.exp(-value));
}

/**
 * Converts an IEEE 754 binary16 value stored in a 16-bit integer
 * to a JavaScript number.
 */
export function halfToFloat(value) {
  const sign = value & 0x8000 ? -1 : 1;
  const exponent = (value >> 10) & 0x1f;
  const fraction = value & 0x03ff;

  if (exponent === 0) {
    if (fraction === 0) {
      return sign * 0;
    }

    return sign * 2 ** -14 * (fraction / 1024);
  }

  if (exponent === 31) {
    return fraction ? NaN : sign * Infinity;
  }

  return sign * 2 ** (exponent - 15) * (1 + fraction / 1024);
}
